<template>
  <div id="post-mark-ad-auto">
    <template v-if="isShow()">
      <div class="pt-3 pb-3">
        <div class="row">
          <span class="col-12">
            <span
                data-bs-toggle="modal"
                data-type="update"
                data-bs-target="#modal-post-mark"
                :data-object='JSON.stringify({
                  post_id: getPostId(),
                  post_status: getPostStatus(),
                  post_payload: getPostPayload(),
                  channel_id: getChannelIdPayload(),
                  type_id: getTypeId()
                })'
            >
              <button class="btn w-100">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-tag me-1">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                  <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" />
                </svg>
                <template v-if="getIsMarkPayload()">
                  Перемаркировать
                </template>
                <template v-else>
                  Маркировать
                </template>
              </button>
            </span>
          </span>
        </div>
      </div>
    </template>
  </div>
  <Teleport to="body">
    <MarkModal />
  </Teleport>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import MarkModal from "./components/mark_ad_modal/Index"

export default defineComponent({
  name: "MarkAdAuto",
  components: {
    MarkModal,
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    let show = ref(false)

    const payload = reactive({
      post_id: null,
      post_status: null,
      post_payload: {},
      is_mark: false,
      channel_id: null,
      type_id: null,
    })

    onMounted(async () => {
      updatePayload(props.payload)
      show.value = true
    })

    watch(() => props.payload, (val) => {
      updatePayload(val)
    })

    function updatePayload(query) {
      payload.post_id = query.post_id
      payload.post_status = query.post_status
      payload.post_payload = query.post_payload
      payload.is_mark = query.is_mark
      payload.channel_id = query.channel_id
      payload.type_id = query.type_id
    }

    function isShow() {
      return show.value === true
    }

    function getPostId() {
      return payload.post_id
    }

    function getTypeId() {
      return payload.type_id
    }

    function getPostStatus() {
      return payload.post_status
    }

    function getPostPayload() {
      return payload.post_payload
    }

    function getChannelIdPayload() {
      return payload.channel_id
    }

    function getIsMarkPayload() {
      return payload.is_mark
    }

    return {
      getPostId,
      getPostStatus,
      isShow,
      getPostPayload,
      getIsMarkPayload,
      getChannelIdPayload,
      getTypeId,
    }
  }
})
</script>
